// gatsby-browser.js
import './src/global.css';

export const onRouteUpdate = ({ location }) => {
  // Cleanup: Always remove revamp CSS on route change
  // The ProductTemplate component will reload it if the 3D modal is opened
  // This ensures CSS doesn't persist when navigating away from product pages
  const cssLink = document.querySelector('link[href="/static/css/main.5b737e1c.css"]')
  if (cssLink) {
    cssLink.remove()
    console.log('Revamp CSS removed on route change')
  }
  document.body.classList.remove('revamp-modal-open')

  // 1. Capture UTM from URL and store in session
  const searchParams = new URLSearchParams(location.search);
  const utmParams = [];
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith('utm_')) {
      utmParams.push(`${key}=${value}`);
    }
  }

  // Store UTM params in sessionStorage if available
  if (utmParams.length > 0) {
    sessionStorage.setItem('utmParams', utmParams.join('&'));
  }

  // 2. Add UTM to sensei3d links from sessionStorage
  const updateSenseiLinks = () => {
    const storedUtm = sessionStorage.getItem('utmParams');
    if (storedUtm) {
      const links = document.querySelectorAll('a[href*="sensei3d"]');
      links.forEach(link => {
        const currentUrl = link.getAttribute('href');
        if (!currentUrl.includes(storedUtm)) {
          const newUrl = currentUrl.includes('?')
            ? `${currentUrl}&${storedUtm}`
            : `${currentUrl}?${storedUtm}`;
          link.setAttribute('href', newUrl);
        }
      });
    }
  };

  // Run update on page load and route change
  if (document.readyState === 'complete') {
    updateSenseiLinks();
  } else {
    window.addEventListener('load', updateSenseiLinks);
  }
};

// gatsby-browser.js
export const onPreRouteUpdate = () => {
  // Pre-route update hook - currently no action needed
};